import { useEffect, useState } from 'react';

let archivePromise;

function archiveUrl() {
  return `${process.env.PUBLIC_URL || ''}/archive-data.json`;
}

export function validateArchive(value) {
  if (!value || !Array.isArray(value.collections) || !Array.isArray(value.blogs) || !Array.isArray(value.links) || !Array.isArray(value.kinds) || !Array.isArray(value.manufacturers)) {
    throw new Error('Nieprawidłowy plik archiwum.');
  }
  return value;
}

export function loadArchive() {
  if (!archivePromise) {
    archivePromise = fetch(archiveUrl(), { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Nie udało się pobrać archiwum (${response.status}).`);
        return response.json();
      })
      .then(validateArchive);
  }
  return archivePromise;
}

export function useArchive() {
  const [archive, setArchive] = useState(null);
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    loadArchive().then(
      (data) => { if (active) setArchive(data); },
      (reason) => { if (active) setError(reason); },
    );
    return () => { active = false; };
  }, [attempt]);

  return { archive, error, retry: () => { archivePromise = undefined; setError(null); setAttempt((value) => value + 1); } };
}

const text = (value) => String(value || '').toLocaleLowerCase('pl');
const hasText = (entry, query, fields) => !query || fields.some((field) => text(entry?.[field]).includes(query));

export function sortBy(entries = [], field = 'Name', direction = 'ASC') {
  return [...entries].sort((left, right) => {
    const result = String(left?.[field] || '').localeCompare(String(right?.[field] || ''), 'pl');
    return direction === 'DESC' ? -result : result;
  });
}

export function filterCollections(entries = [], { query = '', kinds = [], manufacturers = [] } = {}) {
  const normalizedQuery = text(query.trim());
  return entries.filter((entry) => {
    if (kinds.length && !kinds.includes(entry?.kind?.id)) return false;
    if (manufacturers.length && !manufacturers.includes(entry?.manufacturer?.id)) return false;
    return hasText(entry, normalizedQuery, ['Name', 'Procesor', 'RokProdukcji'])
      || text(entry?.kind?.Name).includes(normalizedQuery)
      || text(entry?.manufacturer?.Name).includes(normalizedQuery);
  });
}

export function filterLinks(entries = [], { query = '', manufacturers = [] } = {}) {
  const normalizedQuery = text(query.trim());
  return entries.filter((entry) => {
    const linkedManufacturers = Array.isArray(entry?.manufacturers) ? entry.manufacturers : [];
    if (manufacturers.length && !linkedManufacturers.some((manufacturer) => manufacturers.includes(manufacturer.id))) return false;
    return hasText(entry, normalizedQuery, ['Name', 'Description', 'Link'])
      || linkedManufacturers.some((manufacturer) => text(manufacturer?.Name).includes(normalizedQuery));
  });
}

export function pageOf(entries = [], page = 1, pageSize = 24) {
  const total = entries.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const currentPage = Math.min(Math.max(page, 1), totalPages);
  return { entries: entries.slice((currentPage - 1) * pageSize, currentPage * pageSize), total, totalPages, page: currentPage };
}
